module.exports = __webpack_public_path__ + "img/Equipa_Sinal_1.51f40944.png";